<template>
<div class="card">
   <h6>YOUR CURRENT ENERGY SUPPLY</h6>
   <h4>How do you pay for your gas?</h4>

   <div class="row">
      <div class="col-xs-6" :class="{ 'col-md-3' : showPrepayment != false, 'col-md-4' : showPrepayment == false }" v-if="!showPrepayment">
         <radio-button
            v-model="quote.gasCurrentPayMethod"
            value="monthlyDirectDebit"
            @change="onChoose()"
            :error="$v.gasCurrentPayMethod.$error">Monthly Direct Debit</radio-button>
      </div>

      <div class="col-xs-6" :class="{ 'col-md-3' : showPrepayment != false, 'col-md-4' : showPrepayment == false }" v-if="!showPrepayment">
         <radio-button
            v-model="quote.gasCurrentPayMethod"
            value="quarterlyDirectDebit"
            @change="onChoose()"
            :error="$v.gasCurrentPayMethod.$error">Quarterly Direct Debit</radio-button>
      </div>

      <div class="col-xs-6" :class="{ 'col-md-3' : showPrepayment != false, 'col-md-4' : showPrepayment == false }" v-if="!showPrepayment">
         <radio-button
            v-model="quote.gasCurrentPayMethod"
            value="cashOrCheque"
            @change="onChoose()"
            :error="$v.gasCurrentPayMethod.$error">Cash & Cheque</radio-button>
      </div>

      <div class="col-xs-6 col-md-3" v-if="showPrepayment != false">
         <radio-button
            v-model="quote.gasCurrentPayMethod"
            value="prePaymentMeter"
            @change="onChoose()"
            :error="$v.gasCurrentPayMethod.$error">Prepayment</radio-button>
      </div>
   </div>

   <uiv-alert class="_margin-top-10" type="danger" v-if="$v.gasCurrentPayMethod.mustBePrepayment === false">
      <b>Must be a Prepayment meter</b> <br />
      Unfortunately, as you have a prepayment meter for only one of your fuels, you cannot compare both your gas and electricity at the same time. Please compare gas seperately and electricty seprately.
   </uiv-alert>
</div>
</template>

<script>
import RadioButton from '../../../../base/components/forms/RadioButton';

import { mapState, mapActions } from 'vuex';

export default {
  name: 'PaymentTypeGas',
  props: {
    $v: Object
  },
  computed: {
    ...mapState({
      quote: ({ quote }) => quote,
      showPrepayment: ({ quote }) => {
        const address = quote.address.parts;
        if(!address) return true;
        const gasdetails = address.gasdetails.find(({ isDomestic }) => isDomestic) || {};
        return gasdetails.isPrepayment;
      }
    })
  },
  methods: {
    ...mapActions({
      getSuppliers: 'lookups/getSuppliers'
    }),
    async onChoose () {
      this.$v.gasCurrentPayMethod.$touch();

      if (this.$v.gasCurrentPayMethod.$invalid) return;

      const paymentMethods = [
        this.quote.gasCurrentPayMethod,
        this.quote.electricityCurrentPayMethod
      ];

      this.quote.newTariffPaymentMethod = paymentMethods.indexOf('prePaymentMeter') > -1 ? 'prePaymentMeter' : 'monthlyDirectDebit';
      this.quote.electricityCurrentPayMethod = null;

      this.getSuppliers('gas');
      this.$store.dispatch('tracing/addAction', { name: 'Page', value: 'Payment Type Gas' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Next' });
      await this.$store.dispatch('tracing/saveActions');
    }
  },
  components: {
    RadioButton
  }
};
</script>

<style lang="scss">
</style>
